import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { logger } from '../../logger';
import {
  cancelAutoRenewal,
  getAutoRenewalStatus,
  getSubscription,
  postReactivateAutoRenewal,
} from '../api';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import { IAutoRenewalStatus, ISubscriptions } from '../subscriptions/types';
import {
  ESubscriptionsActionType,
  getAutoRenewalStatusAction,
  getAutoRenewalStatusSuccessAction,
  getSubscriptionsAction,
  getSubscriptionsSuccessAction,
  ICancelAutoRenewalAction,
} from './actions';

export function* getSubscriptionsSaga() {
  if (!(yield* checkHasCompletedProfile())) return;

  const response: ISubscriptions = yield call(getSubscription);

  logger.enrichWithTag('subscriptionStatus', response.isSub ? 'SUB' : 'REG');
  yield put(getSubscriptionsSuccessAction(response));
}

export function* getAutoRenewalStatusSaga() {
  if (!(yield* checkHasCompletedProfile())) return;

  const response: IAutoRenewalStatus = yield call(getAutoRenewalStatus);

  yield put(getAutoRenewalStatusSuccessAction(response));
}

export function* cancelAutoRenewalSaga(action: ICancelAutoRenewalAction) {
  yield call(cancelAutoRenewal, action.payload.reason);
  yield put(getAutoRenewalStatusAction());
  yield put(getSubscriptionsAction());
}

export function* postReactivateAutoRenewalSaga() {
  if (!(yield* checkHasCompletedProfile())) return;

  yield call(postReactivateAutoRenewal);
  yield put(getAutoRenewalStatusAction());
  yield put(getSubscriptionsAction());
}

export function* subscriptionsRootSaga() {
  yield all([
    takeLatest(
      ESubscriptionsActionType.GET,
      handleAsyncStatus(getSubscriptionsSaga, EAsyncEventTypes.GET_SUBSCRIPTION)
    ),
    takeLatest(
      ESubscriptionsActionType.GET_AUTO_RENEWAL_STATUS,
      handleAsyncStatus(
        getAutoRenewalStatusSaga,
        EAsyncEventTypes.GET_SUBSCRIPTION_AUTO_RENEWAL_STATUS
      )
    ),
    takeLatest(
      ESubscriptionsActionType.CANCELRA,
      handleAsyncStatus(cancelAutoRenewalSaga, EAsyncEventTypes.CANCEL_RA)
    ),
    takeLatest(
      ESubscriptionsActionType.POST_REACTIVATED,
      handleAsyncStatus(
        postReactivateAutoRenewalSaga,
        EAsyncEventTypes.POST_REACTIVATE_AUTO_RENEWAL
      )
    ),
  ]);
}
